import { useTranslation } from 'react-i18next';
import { SidebarSection, SidebarSectionSubtitle } from '../../template-list/components/styles';
import { Button } from '@salecycle/ui-component-library';
import { ITemplate } from 'entities/template/template';
import { restoreTemplate } from '../../template-list/utils/queries';
import { useMutation, useQueryClient } from 'react-query';
import styled from 'styled-components';
import useNotifications from 'core/notifications/useNotifications';
import { useTemplatesListDispatch } from '../../template-list/context/UseTemplatesListContext';

const RestoreTemplateButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 5px;
`;

export interface RestoreTemplateButtonProps {
  selectedTemplate: ITemplate;
}

export const RestoreTemplateButton = ({ selectedTemplate }: RestoreTemplateButtonProps) => {
  const { t } = useTranslation(['common', 'designs', 'supportedLanguages', 'templates']);
  const { showNotification } = useNotifications();
  const queryClient = useQueryClient();
  const dispatch = useTemplatesListDispatch();

  const restoreTemplateMutation = useMutation(() =>
    restoreTemplate({
      siteId: selectedTemplate.siteId,
      templateId: selectedTemplate.id,
      channel: selectedTemplate.channel,
      t,
    }),
  );

  const handleRestore = () => {
    restoreTemplateMutation.mutate(undefined, {
      onSuccess: () => {
        showNotification(t('designs:designGallery.form.comment.notifications.restoreTemplateSuccess'), 'normal');
        queryClient.invalidateQueries(['templates', true]);
        dispatch({ type: 'RESET_SELECTED_TEMPLATE' });
      },
      onError: (error: any) => {
        const errorMessage =
          error?.response?.data?.message ||
          error?.message ||
          t('designs:designGallery.form.comment.notifications.restoreTemplateError');
        showNotification(errorMessage, 'error');
      },
    });
  };

  return (
    <SidebarSection data-testid="RestoreTemplateSection">
      <SidebarSectionSubtitle data-testid="RestoreTemplateSubTitle">
        {t('designs:designGallery.sidebar.restoreSubtitle')}
      </SidebarSectionSubtitle>
      <RestoreTemplateButtonContainer>
        <Button variation="primary" onClick={handleRestore} width={236}>
          {t('designs:designGallery.sidebar.restoreButton')}
        </Button>
      </RestoreTemplateButtonContainer>
    </SidebarSection>
  );
};
